import React, { useEffect, useState } from "react";
import { useEspelhoVendas } from "services/api/AppWeb_EspelhoVendas";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  headerData?: any;
  unidadeDataReal?: any;
  numeroCotacao?: string;
  idLead: string | undefined;
  refetch: () => void;
}

const NovaOportunidadeModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header
        onClose={() => {
          props?.onClose();
          props?.refetch();
        }}
      />
      <Footer
        headerData={props?.headerData}
        onClose={() => props?.onClose()}
        unidadeDataReal={props?.unidadeDataReal}
        numeroCotacao={props?.numeroCotacao}
        idLead={props?.idLead}
        refetch={props?.refetch}
      />
    </Styles.Container>
  );
};

export default NovaOportunidadeModal;
